export default __webpack_public_path__ + "static/media/download.e1e739a2.svg";